export default __webpack_public_path__ + "static/media/fengzibo.c16ad44b.jpg";